import { useMutation, useQueryClient } from 'react-query';

import { DELETE_CAMPAIGN_RESPONSE } from '../../constants/endpoints';
import api from '../../utils/api';
import { CAMPAIGN_SUBMISSIONS_LIST, CAMPAIGN_SUBMISSION_DETAILS } from './queries';

const deleteCampaignResponse = (responseId) => {
  return api.delete(`${DELETE_CAMPAIGN_RESPONSE}/${responseId}`);
};

export const useDeleteResponse = () => {
  const queryClient = useQueryClient();

  return useMutation(deleteCampaignResponse, {
    onSuccess: () => {
      queryClient.invalidateQueries([CAMPAIGN_SUBMISSIONS_LIST]);
      queryClient.invalidateQueries([CAMPAIGN_SUBMISSION_DETAILS]);
    }
  });
};



// WEBPACK FOOTER //
// ./src/hooks/react-query/useResponsesData.js